"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointCache = exports.PointCacheImpl = void 0;
class PointCacheImpl {
    constructor() {
        this.cache = {};
        this.projection = null;
    }
    reset() {
        this.cache = {};
    }
    setProjection(projection) {
        this.projection = projection;
    }
    getGeoPoint(loc) {
        return this.getPoint(loc.coordinates[1], loc.coordinates[0]);
    }
    getPoint(lat, lng) {
        var cacheKey = `${lat}:${lng}`;
        var point = this.cache[cacheKey];
        if (this.projection == null) {
            return null;
        }
        if (point == null && this.projection != null) {
            var latLng = new google.maps.LatLng(lat, lng);
            point = this.cache[cacheKey] = this.projection.fromLatLngToDivPixel(latLng);
        }
        return point;
    }
}
exports.PointCacheImpl = PointCacheImpl;
exports.PointCache = new PointCacheImpl();
//# sourceMappingURL=projection.cache.js.map